export const getHowMuchWillFit = (containerWidth: number, blockSize: number) => {
    return Math.floor(containerWidth / blockSize);
}